import { NgModule } from '@angular/core';
import { InputTextboxComponent } from './input-textbox.component';
import { CommonModule } from '@angular/common';
import { InputSharedModule } from '../input-shared.module';
import { InputPasswordMeterComponent } from './input-password-meter/input-password-meter.component';


@NgModule({
  declarations: [
    InputTextboxComponent,
    InputPasswordMeterComponent
  ],
  imports: [
    CommonModule,
    InputSharedModule
  ],
  exports: [
    InputTextboxComponent
  ]
})
export class InputTextboxModule {
}
